import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import {
  HomeStudentsPage,
  Login,
  FinishPaymentPage,
  SectionPayment,
  ClaCheckoutPage,
  ClaInvitacionCheckoutPage,
  ClaResultPage
} from './pages';
import { SectionDiscounts} from './pages/admin/section-discounts';
import { SectionGenerations} from './pages/admin/section-generations';
import { SectionLinks } from './pages/admin/section-links';
import { FormularioResponsePage } from './pages/home-students/FormularioResponse.page';
import { RejectPaymentPage } from './pages/home-students/RejectPaymentPage';
import AuthLogin from './components/AuthLogin';
import { SectionEstadisticas } from './pages/admin/section-estadisticas';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={'/servicio_cliente'}
          element={
            <AuthLogin>
              <SectionLinks />
            </AuthLogin>
          }
        />
				<Route path="/" element={<Navigate to="login" />} />
        <Route path={'/formulario/envelope'} element={<FormularioResponsePage />} />
        <Route path={'/formulario/:typeForm'} element={<HomeStudentsPage />} />
        <Route path={'cla'} element={<ClaCheckoutPage />} />
        <Route path={'cla-inscripcion'} element={<ClaInvitacionCheckoutPage />} />
        <Route path={'cla/gracias'} element={<ClaResultPage success />} />
        <Route path={'cla/rechazado'} element={<ClaResultPage />} />
        <Route path={'login'} element={<Login />} />
        <Route path={'tabla_precios'} element={<SectionPayment />} />
        <Route path={'descuentos'} element={<SectionDiscounts />} />
        <Route path={'generaciones'} element={<SectionGenerations />} />
        <Route path={'estadisticas'} element={<SectionEstadisticas />} />
        <Route path={'pago_aprobado'} element={<FinishPaymentPage />} />
        <Route path={'pago_rechazado'} element={<RejectPaymentPage />} />
        <Route
          path={'error_transbank'}
          element={
            <RejectPaymentPage text="Algo salió mal con Transbank, por favor inténtalo nuevamente o contáctanos" />
          }
        />
        <Route
          path={'error_mercadopago'}
          element={
            <RejectPaymentPage text="Algo salió mal con Mercado Pago, por favor inténtalo nuevamente o contáctanos" />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
